<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Container, Radio, Text } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Types
	import type { InputOutputOptions } from './input_output_types';

	export let typeValue: string, modeValue: string, buttonModeOptions: InputOutputOptions;

	const setButtonMode = async (_modeValue) => {
		modeValue = _modeValue;
	};
</script>

<Container type="base" class="mb-s" padding="xs">
	<Text class="text-bold mb-s">
		{formatSnakeCaseToTitle($format('output_type_label', { default: 'Set output type' }))}
	</Text>
	{#each Object.entries(buttonModeOptions) as option}
		<Radio
			size="m"
			bind:selected={modeValue}
			value={option[0]}
			class="mb-s"
			disabled={option[1].type !== typeValue && option[1].type !== 'any'}
			on:click={() => setButtonMode(option[0])}
			id="radio-wbi4xig"
			info={$showNewLayout ? option[1]?.description : undefined}
		>
			{$showNewLayout ? option[1]?.title : option[1]?.text}
		</Radio>
	{/each}
</Container>
